import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import CustomModal from '../CustomModal';

import { slotKeyCell0, validSlotKeys } from './cell-settings-shared';

const ActivateSimModal = ({
  modal,
  onHide,
  onSlotSelectAndPowerOff,
  onSlotSelectAndReboot,
  slotInfo,
}) => {
  const { slotName, cardName, slotKey, isFixed } = slotInfo;

  const selectAndPowerOff = () => {
    onHide(false, false);
    onSlotSelectAndPowerOff(slotKey);
  };

  const selectAndReboot = () => {
    onHide(false, false);
    onSlotSelectAndReboot(slotKey);
  };

  return (
    <CustomModal modal={modal} onHide={onHide} size={isFixed ? 'md' : 'lg'}>
      <CustomModal.Header centered onHide={onHide}>
        {slotKey === slotKeyCell0 ? (
          <div>The KVH Global SIM will be active upon a system restart</div>
        ) : (
          <div>
            The &quot;{cardName || slotName}&quot; SIM will be active upon a
            system restart
          </div>
        )}
      </CustomModal.Header>
      <CustomModal.Body>
        {isFixed && (
          <div>
            <div className="text-center">
              You will be logged out momentarily after initiating a restart.
            </div>
            <div className="pb-4 text-center font-weight-bold">
              Please ignore any error messages encountered until the terminal
              fully reboots.
            </div>
            <div className="px-2 pt-4 d-flex justify-content-center">
              <Button
                variant="link"
                className="text-capitalize mx-4"
                onClick={() => onHide(false)}
              >
                Cancel
              </Button>
              <Button type="submit" className="mx-4" onClick={selectAndReboot}>
                Activate SIM &amp; Restart
              </Button>
            </div>
          </div>
        )}
        {!isFixed && (
          <div>
            <div className="text-center">
              You will be logged out momentarily after initiating a
              restart/shutdown.
            </div>
            <div className="pb-4 text-center font-weight-bold">
              Please ignore any error messages encountered until the terminal
              fully reboots.
            </div>
            <Row className="px-2 pt-4 pb-0">
              <Col xs={12} lg={7} className="p-1 m-0">
                <div className="m-1 p-2 border">
                  <div className="my-2 text-center font-weight-bold">
                    If the selected SIM is not yet installed in the BDU:
                  </div>
                  <div className="my-4">
                    <ol type="1" className="pl-5 pr-1">
                      <li>
                        Select <strong>Activate SIM &amp; Power Off.</strong>
                      </li>
                      <li>
                        While the system is off, insert your SIM card in the
                        selected BDU SIM card slot.
                      </li>
                      <li>Power the system back on to use the new SIM card.</li>
                    </ol>
                  </div>
                  <div className="my-4 d-flex justify-content-center">
                    <Button type="submit" onClick={selectAndPowerOff}>
                      Activate SIM &amp; Power Off
                    </Button>
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={5} className="p-1 m-0">
                <div className="m-1 p-2 border">
                  <div className="my-2 text-center font-weight-bold justify-content-center">
                    If the selected SIM is already installed in the BDU:
                  </div>
                  <div className="my-4 text-center">
                    Select <strong>Activate SIM &amp; Restart.</strong> The
                    system will use the selected SIM upon restart.
                  </div>
                  <div className="my-4 d-flex justify-content-center">
                    <Button type="submit" onClick={selectAndReboot}>
                      Activate SIM &amp; Restart
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </CustomModal.Body>
      {!isFixed && (
        <CustomModal.Footer className="pt-0">
          <Button
            variant="link"
            className="text-capitalize"
            onClick={() => onHide(false)}
          >
            Cancel
          </Button>
        </CustomModal.Footer>
      )}
    </CustomModal>
  );
};

const SlotInfo = {
  slotName: PropTypes.string.isRequired,
  cardName: PropTypes.string,
  slotKey: PropTypes.oneOf(validSlotKeys),
  isFixed: PropTypes.bool,
};

ActivateSimModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSlotSelectAndPowerOff: PropTypes.func.isRequired,
  onSlotSelectAndReboot: PropTypes.func.isRequired,
  slotInfo: PropTypes.shape(SlotInfo).isRequired,
};

export default ActivateSimModal;
